import { css, styled } from 'styled-components';

import { Image } from 'app/components/image';
import { breakpointLargeTablet } from 'app/style/breakpoints';
import { colorSecondary100, colorSecondary200 } from 'app/style/colors';
import { spacing2, spacing3, spacing4 } from 'app/style/spacing';

const ICON_SIZE = '70px';

interface StyledIconProps {
    $loading?: boolean;
}

const iconShadowStyles = css`
    filter: drop-shadow(0 2px 4px rgb(0 0 0 / 15%));
    border: 1px solid ${colorSecondary100};
`;

export const StyledIconContainer = styled.div<StyledIconProps>`
    height: ${ICON_SIZE};
    box-sizing: border-box;
    flex: 0 0 ${ICON_SIZE};
    border-radius: 100%;
    position: relative;
    margin-bottom: ${spacing2};
    ${({ $loading }) => !$loading && iconShadowStyles};

    @media (min-width: ${breakpointLargeTablet}) {
        margin-bottom: 0;
    }
`;

export const StyledIcon = styled(Image)`
    position: absolute;
    inset: 0;
    margin: auto;
`;

export const StyledContent = styled.div`
    margin-left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    text-align: center;

    @media (min-width: ${breakpointLargeTablet}) {
        margin-left: ${spacing3};
        min-height: ${ICON_SIZE};
        text-align: left;
    }
`;

export const StyledInformationStep = styled.div`
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    ${StyledIconContainer} {
        margin-top: ${spacing4};
    }

    &::before {
        position: absolute;
        background: ${colorSecondary200};
        width: 2px;
        height: ${spacing4};
        content: '';
        left: 0;
        right: 0;
        top: 0;
        margin: 0 auto;
    }

    &:first-child {
        ${StyledIconContainer} {
            margin-bottom: ${spacing3};
            margin-top: 0;
        }

        &::before {
            height: ${spacing3};
            top: ${ICON_SIZE};
        }
    }

    &:not(:first-child) {
        margin-bottom: ${spacing3};
    }

    @media (min-width: ${breakpointLargeTablet}) {
        flex-wrap: nowrap;
        justify-content: left;
        margin-top: ${ICON_SIZE};

        ${StyledIconContainer} {
            margin-top: 0;
            margin-bottom: 0;
        }

        &::before,
        &:first-child::before {
            height: 100%;
            left: 34px;
            top: ${ICON_SIZE};
            margin: 0;
        }

        &:last-child::before {
            display: none;
        }
    }
`;
